 @if (openOrders()?.length > 0) {
    <div class="open-line-container flex-layout">
        <div style="position: relative; top: 0.25rem">
          Order # {{ openOrders()[0]?.orderNumber }} exists, but has open lines.
          @if (openOrders()[0]?.orderSourceSystem === dynamicsSourceSystem) {
            <mat-icon class="small-icon" title="Dynamics" aria-hidden="true">verified</mat-icon>
          }
        </div>
        <div class="tooltip-button" placement="right" #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
            See details
            <insight-popup-tooltip [overlayOrigin]="overlayOrigin">
                <ng-template>
                    <div>
                        <div>Sales Rep: {{ openOrders()[0]?.accountExec }}</div>
                        <div>{{ openOrders()[0]?.customerName }} ({{ openOrders()[0]?.customerNumber }})</div>
                    </div>

                    <ul>
                    @for (openOrd of openOrders(); track openOrd.orderNumber + ':' + openOrd.lineNumber) {
                        <li>
                          Line #{{ openOrd.lineNumber }} - {{ openOrd.title }} ({{ openOrd.productNumber }})
                        </li>
                    }
                    </ul>
                </ng-template>
            </insight-popup-tooltip>
        </div>
    </div>
 }
